import { useCallback, useEffect } from 'react'
import { processSyncQueue } from '../offline/sync-orchestrator'

/**
 * @param {Function} apiRequest - from useHttpApiNew
 * @param {Function} [onSyncDone] - called after each sync attempt (success or empty queue)
 */
export default function useOfflineSync(apiRequest, onSyncDone) {
  const runSync = useCallback(async () => {
    try {
      return await processSyncQueue(apiRequest, {})
    } finally {
      onSyncDone?.()
    }
  }, [apiRequest, onSyncDone])

  useEffect(() => {
    runSync().catch(() => {})

    const onOnline = () => {
      runSync().catch(() => {})
    }
    const onVis = () => {
      if (document.visibilityState === 'visible') {
        runSync().catch(() => {})
      }
    }
    const interval = window.setInterval(() => {
      if (typeof navigator !== 'undefined' && navigator.onLine) {
        runSync().catch(() => {})
      }
    }, 30 * 1000)
    window.addEventListener('online', onOnline)
    document.addEventListener('visibilitychange', onVis)
    return () => {
      window.removeEventListener('online', onOnline)
      document.removeEventListener('visibilitychange', onVis)
      window.clearInterval(interval)
    }
  }, [runSync])

  return { runSync }
}
